import React from 'react';

// Which flip-container slot a subtree is rendered in:
//   'idle'     — the base slot at rest (the live, interactive page)
//   'upcoming' — the base slot while a flip is in progress (target page underlay)
//   'fold'     — one of the duplicated fold/slide overlay slots that exist only
//                for the duration of the animation. Heavy media (e.g. background
//                videos) should render poster-only here: the slot lives < 550ms
//                and is non-interactive, so mounting players is wasted main-thread
//                work at the exact frame the animation starts.
// Lives in its own module so consumers (background/VideoView) can read it without
// importing the flip container (and its scss) — keeps the dependency edge one-way.
export const FlipSlotContext = React.createContext('idle');
